export const TENOR_ORDER=["1W","1M","2M","3M","6M","9M","1Y"];
export const TENOR_DAYS={"1W":7,"1M":30,"2M":60,"3M":91,"6M":182,"9M":274,"1Y":365};
